exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.paySchedule[data-v-b7eff7c4]{width:100%;border-collapse:collapse}.paySchedule td[data-v-b7eff7c4]{border:1px solid #ccc;line-height:41px;text-align:center}.paySchedule tr.tb-td td[data-v-b7eff7c4]{font-weight:700}td.textCenter[data-v-b7eff7c4]{text-align:center}td.textRight[data-v-b7eff7c4]{text-align:right}td input[data-v-b7eff7c4]{width:100%;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b7eff7c4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/project_info/Voucher/voucher_form.vue
// module id = 1094
// module chunks = 3